const faqItems = [
  {
    q: '6080新视觉影院需要注册才能观看吗？',
    a: '不需要。6080新视觉影院所有高清电影电视剧均支持免费在线观看，无需注册登录，打开即可播放。',
  },
  {
    q: '为什么播放时偶尔会出现卡顿？',
    a: '卡顿通常与您的网络环境有关。6080新视觉影院采用多线路智能切换技术，建议切换播放线路或降低清晰度档位，即可恢复流畅播放。',
  },
  {
    q: '支持哪些设备观看？',
    a: '6080新视觉影院全面适配PC、平板、手机等多种设备，支持主流浏览器访问。同时提供APP客户端下载，移动端体验更佳。',
  },
  {
    q: '资源多久更新一次？',
    a: '平台每日更新200+部电影电视剧资源，热门新片和剧集通常在播出后24小时内上线，确保您第一时间看到最新内容。',
  },
  {
    q: '6080新视觉影院是否安全？',
    a: '平台承诺纯净观影体验，无弹窗广告，无恶意插件，不收集用户隐私数据。我们持续优化安全策略，保障用户观影安全。',
  },
  {
    q: '如何反馈问题或建议？',
    a: '您可以通过页面底部的"联系我们"区域提交反馈。我们重视每一条用户意见，通常会在48小时内回复处理。',
  },
];

const comments = [
  {
    name: '光影追梦人',
    text: '用了三年了，资源更新速度真的快，热门剧集隔天就有高清版，而且真的不卡顿，体验比很多付费平台还好。',
    time: '3天前',
    rating: 5,
  },
  {
    name: '剧荒拯救者',
    text: '朋友推荐的6080新视觉影院，片库太全了！连很多冷门老片都能找到，高清画质在线观看完全不缓冲，强烈推荐！',
    time: '5天前',
    rating: 5,
  },
  {
    name: '深夜观影人',
    text: '作为重度影视爱好者，6080是我用过加载最快的免费影视平台。极速秒开不是吹的，移动端APP体验同样出色。',
    time: '1周前',
    rating: 5,
  },
  {
    name: '周末剧场',
    text: '无广告真的太重要了！以前在其他站看片被弹窗烦死，6080新视觉影院的纯净观影体验让人上瘾，已经成为唯一的追剧工具。',
    time: '2周前',
    rating: 4,
  },
];

export default function FAQCommentsSection() {
  return (
    <>
      <section id="faq" className="relative w-full py-16 md:py-20 bg-background-100">
        <div className="max-w-3xl mx-auto px-4 md:px-6">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
              常见问题
            </h2>
            <p className="text-sm text-foreground-500">
              关于高清电影电视剧免费在线观看的常见疑问解答
            </p>
          </div>
          <div className="space-y-3">
            {faqItems.map((item, idx) => (
              <div
                key={idx}
                className="bg-background-50 rounded-lg p-4 md:p-5 border border-background-200/40"
              >
                <h3 className="text-sm md:text-base font-semibold font-heading text-foreground-800 mb-2">
                  {item.q}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                  {item.a}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section id="comments" className="relative w-full py-16 md:py-20 bg-background-50">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
              用户评价
            </h2>
            <p className="text-sm text-foreground-500 max-w-lg mx-auto">
              来自真实用户的观影体验分享
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            {comments.map((item, idx) => (
              <div
                key={idx}
                className="bg-background-100 rounded-lg p-4 md:p-5 border border-background-200/40"
              >
                <div className="flex items-center gap-1 mb-3">
                  {Array.from({ length: item.rating }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-xs text-primary-400"></i>
                  ))}
                </div>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed mb-4">
                  "{item.text}"
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-xs font-medium text-foreground-700">{item.name}</span>
                  <span className="text-xs text-foreground-400">{item.time}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}